import React from "react";
import { Wrapper } from "./styles";

export interface AnimatedWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  isVisible?: boolean;
  durationMs?: number;
  easing?: string;
  animateOnFocusWithin?: boolean; // Accessibility - allows hidden controls to be visible when tabbed to
  className?: string;
  children?: React.ReactNode;
}

const AnimatedWrapper: React.FC<AnimatedWrapperProps> = ({
  isVisible,
  durationMs = 250,
  easing = "ease",
  animateOnFocusWithin = true,
  children,
  className,
  ...rest
}) => {
  const resolvedVisible = !!isVisible;

  return (
    <Wrapper
      $isVisible={resolvedVisible}
      $durationMs={durationMs}
      $easing={easing}
      $animateOnFocusWithin={animateOnFocusWithin}
      className={className}
      {...rest}
    >
      {children}
    </Wrapper>
  );
};

export default AnimatedWrapper;
